import { gqlClient } from '../../components/AppProvider';
import { AppDispatch, AppThunk } from '../../store';
import { getErrorMessage } from '../../util/Common';
import { RequestResult, GetBlobStorageDocumentInput, PagingResultModelOfBlobStorageModel, BlobUploadRequestInput } from '../../gql-types.generated';
import { queryBlobStorageFileVersionList } from '../../gql/QueryBlobStorageFileVersionList';
import { mutationDeleteEntity } from '../../gql/MutationDeleteEntity';
import { 
    captureDeleteSefFileStatus, 
    captureUploadSefFileStatus, 
    fetchError, 
    fetchSefFileListSuccess,
    incrementSefFileRequestsInFlight,
    decrementSefFileRequestsInFlight
} from './StandardExchangeFormatFilesSlice';
import { MutationUploadBlogStorage } from '../../gql/MutationExecuteBlobStorageUpload';

export const fetchSefFileList = (
    filters?: GetBlobStorageDocumentInput
) => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(incrementSefFileRequestsInFlight());
    try {
        const fileList = await queryBlobStorageFileVersionList(gqlClient, filters);
        if (fileList) {
            dispatch(fetchSefFileListSuccess(fileList as PagingResultModelOfBlobStorageModel))
        }
        dispatch(decrementSefFileRequestsInFlight());
    } catch (e) {
        dispatch(fetchError(e as Error));
        dispatch(decrementSefFileRequestsInFlight());
    }
};

export const uploadStandardExchangeFormatFile = (fileUploadData: BlobUploadRequestInput): AppThunk =>
    async (dispatch: AppDispatch): Promise<void> => {
        try {
            const uploadStatus = await MutationUploadBlogStorage(gqlClient, fileUploadData);
           
            if (uploadStatus) {
                if (uploadStatus.result === RequestResult.Fail) {
                    dispatch(fetchError({ message: uploadStatus.message } as Error));
                    getErrorMessage(uploadStatus.message as string, uploadStatus.errors, true, true);
                }
                dispatch(captureUploadSefFileStatus(uploadStatus));
            }
        } catch (e) {
            dispatch(fetchError(e as Error));
        }
    };

export const deleteStandardExchangeFormatFile = (id: string): AppThunk =>
    async (dispatch: AppDispatch): Promise<void> => {
        try {
            const deleteStatus = await mutationDeleteEntity(gqlClient, {
                id,
                entityName: "BlobStorage",
            });
            if (deleteStatus) {
                if (deleteStatus.result === RequestResult.Fail) {
                    getErrorMessage(deleteStatus.message as string, deleteStatus.errors, true, true);
                }
                dispatch(captureDeleteSefFileStatus(deleteStatus));
            }
        } catch (e) {
            dispatch(fetchError(e as Error));
        }
    };